// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3Y9yW","balanceDisclaimer":"posDashboard_balanceDisclaimer__2pd94"};